import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';

// ==============================|| AUTH GUARD ||============================== //
// Girişi olmayan kullanıcıyı /login'e yönlendirir. Geçici parolayla giriş yapmış
// (parolaDegisikligiGerekli) kullanıcıyı ise, rolü ne olursa olsun, zorunlu parola
// değiştirme ekranına yönlendirir — bu kontrol RoleGuard'dan önce burada yapılır.

export const ZORUNLU_PAROLA_DEGISTIR_PATH = '/parola-degistir-zorunlu';

export default function AuthGuard({ children }) {
  const { isLoggedIn, parolaDegisikligiGerekli } = useAuth();
  const location = useLocation();

  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (parolaDegisikligiGerekli && location.pathname !== ZORUNLU_PAROLA_DEGISTIR_PATH) {
    return <Navigate to={ZORUNLU_PAROLA_DEGISTIR_PATH} replace />;
  }

  return children;
}

AuthGuard.propTypes = { children: PropTypes.node };
